<div
	class="modalBaseWrapper {{ modalIdentifier }} {{ gridLayout }}"
	[ngClass]="{
		'mainContentIsScrolled': mainContentIsScrolled
	}"
>

	<!-- Modal Header Content -->
	<div
		#modalHeader
		*ngIf="renderModalHeader"
		class="modal-header row mx-0 flex-nowrap"
		[ngClass]="{
			'hideHeader': hideModalHeader
		}"
	>
		<!-- Modal Header Title Content -->
		<p
			*ngIf="modalHeaderContentTypeEnum.VALUE === modalHeaderContentType"
			class="header-title col my-auto ps-0"
		>{{ headerTitle }}</p>

		<!-- Modal Header Projected Content -->
		<ng-content
			*ngIf="modalHeaderContentTypeEnum.PROJECTED === modalHeaderContentType"
			select=".header-content"
		></ng-content>

		<!-- Modal Header Close Button -->
		<ng-container [ngTemplateOutlet]="closeTpl"></ng-container>
	</div>

	<ng-container *ngIf="hideModalHeader || !renderModalHeader" [ngTemplateOutlet]="closeTpl"></ng-container>

	<!-- Modal Subheader Content -->
	<div

		#modalSubheader
		*ngIf="renderModalSubheader"
		class="modal-subheader row mx-0 fs-md {{ modalSubheaderStyleClasses }}"
		[ngClass]="{
			'hideSubheader': hideModalSubheader
		}"
	>

		<!-- Modal Subheader Loader Overlay -->
		<ng-container
			*ngIf="renderModalSubheader && !hideModalSubheader"
			[ngTemplateOutlet]="modalSectionsLoaderOverlayTpl"
			[ngTemplateOutletContext]="{ projectedContentType: 'subheaderOverlay' }"
		></ng-container>

		<!-- Modal Subheader Projected Content -->
		<ng-content select=".subheader-content"></ng-content>
	</div>

	<!-- Modal Body -->
	<div
		#modalBody
		class="modal-body"
		[ngClass]="{
		'hideModalAside': hideModalAside,
		'showInRows': contentAlignment === alignContentItemsEnum.AS_ROWS,
		'showInColumns': contentAlignment === alignContentItemsEnum.AS_COLUMNS || !contentAlignment
		}"
		appScrollEvent
		(scrollData)="onScroll($event)"
	>

		<!-- Aside -->
		<div
			#modalAside
			*ngIf="renderModalAside"
			class="modal-aside"
		>
			<!-- Modal Aside Projected Content -->
			<ng-content select=".aside-content"></ng-content>
		</div>

		<!-- Main Content-->
		<div
			#modalMain
			class="modal-main {{ modalMainStyleClasses }}"
			[ngClass]="modalMainStyleClassMap"
		>
			<!-- Modal Main Projected Content -->
			<ng-content select=".main-content"></ng-content>
		</div>
	</div>

	<!-- Modal Content Overlay -->
	<div
		@fadeInOut
		*ngIf="renderModalContentOverlay && showModalContentOverlay"
		class="modal-content-overlay position-absolute w-100 showOverlay {{ modalContentOverlayStyleClasses }}"
		[ngClass]="{
			'showLoader': showLoader
		}"
		[ngStyle]="{
			'height': modalOverlayOffsetHeight,
			'top': modalOverlayOffsetTop
		}"
	>

		<!-- Modal Overlay Projected Content -->
		<ng-content
			*ngIf="showProjectedModalOverlay"
			select=".content-overlay">
		</ng-content>

		<!-- Modal Overlay Loader -->
		<app-loader
			*ngIf="showLoader"
			[asOverlay]="true"
			[effect]="'circle'"
			[overlaySvgAlignment]="loaderOverlaySvgAlignmentEnum.CENTER"
			[overlaySvgPosition]="loaderOverlaySvgPositionEnum.RELATIVE"
			[showLoader]="requestInProgress"
			[size]="'xl'"
		></app-loader>
	</div>

	<!-- Pre-Footer Content-->
	<div
		*ngIf="renderModalPreFooter"
		class="modal-pre-footer m-0"
		[ngClass]="{
			'hidePreFooter': hideModalPreFooter
		}"
	>
		<!-- Modal Pre-Footer Loader Overlay -->
		<ng-container
			*ngIf="renderModalPreFooter && !hideModalPreFooter"
			[ngTemplateOutlet]="modalSectionsLoaderOverlayTpl"
			[ngTemplateOutletContext]="{ projectedContentType: 'preFooterOverlay' }"
		></ng-container>

		<!-- Modal Pre-Footer Projected Content -->
		<ng-content select=".pre-footer-content"></ng-content>
	</div>

	<!-- Footer Content-->
	<div
		*ngIf="renderModalFooter"
		class="modal-footer m-0"
		[ngClass]="{
			'hideFooter': hideModalFooter
		}"
	>
		<!-- Modal Footer Projected Content -->
		<ng-content select=".footer-content"></ng-content>
	</div>

	<ng-content></ng-content>
</div>

<!-- ######################### TEMPLATES ######################### -->
<ng-template #closeTpl>
	<i
		*ngIf="renderModalHeaderCloseButton"
		class="close-modal col-auto ft-x"
		[ngClass]="{
			'my-auto': !hideModalHeader && renderModalHeader,
			'disabled': requestInProgress,
			'fade pe-none': showModalContentOverlay
		}"
		(click)="close()"
	></i>
</ng-template>

<ng-template
	#modalSectionsLoaderOverlayTpl
	let-projectedContentType="projectedContentType"
>
	<div
		@fadeInOut
		*ngIf="renderModalContentOverlay && showModalContentOverlay"
		class="modal-sections-content-overlay"
		[ngSwitch]="projectedContentType"
	>

		<!-- Modal Subheader Content Overlay Projected Content -->
		<ng-container *ngSwitchCase="'subheaderOverlay'">
			<ng-content
				select=".modal-sections-content-overlay-subheader">
			</ng-content>
		</ng-container>

		<!-- Modal Pre-Footer Content Overlay Projected Content -->
		<ng-container *ngSwitchCase="'preFooterOverlay'">
			<ng-content
				select=".modal-sections-content-overlay-pre-footer">
			</ng-content>
		</ng-container>
	</div>
</ng-template>
